import { useState } from 'react';
import {
    Document,
    Page,
    View,
    Text,
    Image,
    StyleSheet,
} from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import { Button, Modal } from 'antd';
import { grayText2, paragraph1, paragraph10, paragraph11, paragraph12, paragraph13, paragraph14, paragraph3, paragraph4, paragraph5, paragraph6, paragraph8, paragraph9 } from './conscent-esketamina-texts';
import { paragraph7 } from './conscent-ketamina-texts';
import { IMAGE_API, myHospitals } from '../../../resources';


//////////////////////////
// Parent: expedientes.jsx
//////////////////////////

const styles = StyleSheet.create({
    page: {
        padding: 32,
        fontSize: 11,
        fontFamily: 'Helvetica',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12,
    },
    logo: {
        width: 80,
        height: 50,
        objectFit: 'contain',
    },
    headerRight: {
        textAlign: 'right',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
    },
    titleHeader: {
        fontSize: 14,
        fontWeight: 700,
        color: '#505050ff',
    },
    date: {
        fontSize: 10,
        marginTop: 2,
        color: '#505050ff',
    },
    grayBox: {
        backgroundColor: '#e0e0e0',
        padding: 10,
        marginBottom: 12,
        borderRadius: 8,
    },
    grayText: {
        fontSize: 12,
        fontWeight: 700,
        textAlign: 'center',
        lineHeight: 1.4,
    },
    paragraphBold: {
        fontWeight: 700,
        marginBottom: 10,
        lineHeight: 1.4,
    },
    paragraph: {
        marginBottom: 10,
        lineHeight: 1.4,
    },
    lineText: {
        marginBottom: 10,
        lineHeight: 1.4,
    },
    bullet: {
        marginLeft: 12,
        marginBottom: 6,
    },
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 32,
        right: 32,
        fontSize: 9,
        textAlign: 'center',
    },
});

export default function ConsentimientoEsketaminaPDF({ pacienteData, fechaLabel }) {
    return (
        <Document>
            <Page size="LETTER" style={styles.page}>
                {/* Header */}
                <View style={styles.header}>
                    <Image src={IMAGE_API + myHospitals[0]?.logo} style={styles.logo} />
                    <View style={styles.headerRight}>
                        <Text style={styles.titleHeader}>R-CDL-057 Consentimiento de Esketamina (SPRAVATO)</Text>
                        <Text style={styles.date}>Ed 0 27/11/2024</Text>
                    </View>
                </View>

                {/* Gray Section */}
                <View style={styles.grayBox}>
                    <Text style={styles.grayText}>
                        CARTA DE CONSENTIMIENTO BAJO INFORMACIÓN{"\n"}
                        AUTORIZACIÓN DE TRATAMIENTO FARMACOLOGICO {"\n"}
                        APLICACIÓN INTRANASAL DE ESKETAMINA (SPRAVATO) {"\n"}
                        CIDERALT SA DE CV
                    </Text>
                </View>

                <Text style={styles.paragraphBold}>{paragraph1}</Text>

                <Text style={styles.lineText}>
                    El subscrito (paciente) {pacienteData.name} o familiar responsable {''}
                    {pacienteData.responsable.nombre || '__________________________________________'} {''} del paciente con número de expediente
                    {pacienteData.no_expediente || '_____________________'} del servicio de {''} {pacienteData.service || '______________________.'}.
                </Text>

                <Text style={styles.paragraph}>{paragraph3}</Text>
                <Text style={styles.paragraph}>{paragraph4}</Text>

                <Text style={styles.lineText}>
                    - Mejora del 80% o más de los síntomas depresivos y de ansiedad medidas a través de escalas clínicas certificadas para este fin.
                </Text>
                <Text style={styles.lineText}>- Remisión total de los pensamientos suicidas o de muerte.</Text>

                <Text style={styles.paragraph}>{paragraph5}</Text>
                <Text style={styles.paragraph}>{paragraph6}</Text>
                <Text style={styles.paragraph}>{paragraph7}</Text>
                <Text style={styles.paragraph}>{paragraph8}</Text>
                <Text style={styles.paragraph}>{paragraph9}</Text>
                <Text style={styles.paragraph}>{paragraph10}</Text>

                <Text style={styles.lineText}>
                    Morelia, Michoacán, a {new Date().toLocaleDateString('es-MX', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} .
                </Text>

                <Text style={styles.lineText}>RESPONSABLE{''}NOMBRE Y FIRMA</Text>
                <Text style={styles.lineText}>
                    MÉDICO TRATANTE{''}NOMBRE, FIRMA Y CEDULA PROFESIONAL
                </Text>

                <Text style={styles.lineText}>PACIENTE</Text>
                <Text style={styles.lineText}>TESTIGO{''}NOMBRE Y FIRMA</Text>
                <Text style={styles.lineText}>NOMBRE Y FIRMA</Text>

                <View style={styles.grayBox}>
                    <Text style={styles.grayText}>{grayText2}</Text>
                </View>

                <Text style={styles.paragraph}>• {paragraph11}</Text>
                <Text style={styles.paragraph}>• {paragraph12}</Text>
                <Text style={styles.paragraph}>• {paragraph13}</Text>
                <Text style={styles.paragraph}>• {paragraph14}</Text>


                {/* Extra Bullets */}
                <View>
                    <Text style={styles.bullet}>• Nombre del médico tratante, cédula profesional y dirección.</Text>
                    <Text style={styles.bullet}>• Nombre o razón social del consultorio.</Text>
                    <Text style={styles.bullet}>• Título del documento.</Text>
                    <Text style={styles.bullet}>• Lugar y fecha.</Text>
                    <Text style={styles.bullet}>• Nombre y firma de la persona que otorga autorización.</Text>
                    <Text style={styles.bullet}>• Nombre y firma de los testigos.</Text>
                </View>

                {/* NOM Section */}
                <View style={{ marginTop: 14 }}>
                    <Text style={styles.bullet}>• NOM-004SSA3-2021 Numeral 10.1 Cartas de consentimiento informado.</Text>
                    <Text style={styles.bullet}>• 10.1.1.- deberá contener como mínimo:</Text>
                    <Text style={styles.bullet}>• 10.1.1.1.- Nombre de la institución.</Text>
                    <Text style={styles.bullet}>• 10.1.1.2.- Nombre o razón social del establecimiento.</Text>
                    <Text style={styles.bullet}>• 10.1.1.3.- Título del documento.</Text>
                    <Text style={styles.bullet}>• 10.1.1.4.- Lugar y fecha de emisión.</Text>
                    <Text style={styles.bullet}>• 10.1.1.5.- Acto autorizado.</Text>
                    <Text style={styles.bullet}>• 10.1.1.6.- Riesgos y beneficios esperados.</Text>
                    <Text style={styles.bullet}>• 10.1.1.7.- Autorización de atención de urgencias derivadas.</Text>
                    <Text style={styles.bullet}>• 10.1.1.8.- Nombre y firma del paciente o responsable.</Text>
                    <Text style={styles.bullet}>• 10.1.1.9.- Nombre y firma del médico tratante.</Text>
                    <Text style={styles.bullet}>• 10.1.1.10.- Nombre y firma de testigo.</Text>
                    <Text style={{ marginTop: 10, textAlign: 'center' }}>“FIN DEL DOCUMENTO”</Text>
                </View>

                {/* Footer */}
                <Text style={styles.footer}>
                    Este documento es propiedad de CIDERALT y no puede ser distribuido sin autorización de los socios
                </Text>
            </Page>
        </Document>
    );
}





export function ConscentEsketaminaModalDocument({ pacienteData, buttonText = "Ver Expediente PDF" }) {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);


    return (
        <div>
            <Button onClick={handleOpen}>{buttonText}</Button>
            <Modal open={isOpen} onCancel={handleClose} width={1000}>
                <PDFViewer style={{ width: '100%', height: '90vh' }}>
                    <ConsentimientoEsketaminaPDF pacienteData={pacienteData} fechaLabel={new Date().toLocaleDateString()} />
                </PDFViewer>
            </Modal>
        </div>
    )

}